import * as React from 'react';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';

export default function BasicSelect(props: {updateFetchRequest: any}) {
  const { updateFetchRequest } = props
  const [year, setYear] = React.useState('2025');

  const handleChange = (event: SelectChangeEvent) => {
    const selectedYear = event.target.value as string;
    setYear(selectedYear);
    updateFetchRequest(selectedYear);
  };

  const yearOptions = [];
  for (let y = 2025; y >= 2000; y--) {
    yearOptions.push(y);
  }

  return (
    <Box sx={{ minWidth: 120, gridColumnStart: 3, gridColumnEnd: 7, gridRowStart: 14, gridRowEnd: 15, backgroundColor: "rgba(200,200,200,0.6)", borderRadius: "4px", zIndex: "1", backdropFilter: "blur(20px)", color: "rgba(217, 217, 217, 0.78)",
     boxShadow: "rgba(0, 0, 0, 0.5) 0px 8px 10px, rgba(0, 0, 0, 0.09) 0px 4px 2px, rgba(0, 0, 0, 0.09) 0px 8px 4px, rgba(0, 0, 0, 0.09) 0px 12px 8px, rgba(0, 0, 0, 0.09) 0px 16px 16px" }}>
      <FormControl fullWidth>
        <InputLabel id="year-select-label" sx={{ color: "rgba(255, 255, 255, 1)", paddingTop: "2px", "&.Mui-focused": { color: "rgba(255, 255, 255, 1)" } }}>Year</InputLabel>
        <Select
          labelId="year-select-label"
          id="year-select"
          value={year}
          label="Year"
          onChange={handleChange}
          MenuProps={{
            PaperProps: {
              sx: {
                maxHeight: '200px',
                backgroundColor: "rgb(24, 61, 61)",
                color: "rgba(255, 255, 255, 1)",
                "& .MuiMenuItem-root": {
                  color: "rgba(255, 255, 255, 1)",
                  "&:hover": {
                    backgroundColor: "rgba(255, 255, 255, 0.1)"
                  }
                }
              }
            }
          }}
          sx={{ 
            color: "rgba(255, 255, 255, 1)",
            backgroundColor: "rgb(24, 61, 61)",
            
            "& .MuiOutlinedInput-root": {
            
              border: "2px solid rgba(247, 247, 247, 0.63)",
              borderRadius: "4px",
              "& fieldset": {
                border: "none"
              }
            }
          }}
        >
          {yearOptions.map((y) => (
            <MenuItem key={y} value={y.toString()}>{y}</MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
}